import { render, staticRenderFns } from "./ContractorHeaderNew.vue?vue&type=template&id=6629b16d&scoped=true"
import script from "./ContractorHeaderNew.vue?vue&type=script&lang=ts"
export * from "./ContractorHeaderNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorHeaderNew.vue?vue&type=style&index=0&id=6629b16d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629b16d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6629b16d')) {
      api.createRecord('6629b16d', component.options)
    } else {
      api.reload('6629b16d', component.options)
    }
    module.hot.accept("./ContractorHeaderNew.vue?vue&type=template&id=6629b16d&scoped=true", function () {
      api.rerender('6629b16d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorHeaderNew.vue"
export default component.exports